import { useEffect, useState } from "react";
import Toast from 'react-bootstrap/Toast';
import { useTranslation } from "react-i18next";

const ErrorToast = ({ errors }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(Boolean(errors));
    var message = errors ? <ul>
        {Object.entries(errors).map(([key, val]) => <li><b>{key}</b>: {val}</li>)}
    </ul> : '';

    useEffect(() => {
        setShow(Boolean(errors));
    }, [errors]);
    return <Toast onClose={() => setShow(false)} show={show} delay={5000} autohide className="toast-danger" style={{
        position: 'fixed',
        top: "70px",
        right: "10px",
        zIndex: 999999,
    }}>
        <Toast.Header>
            <strong className="mr-auto">{t('Error')}</strong>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
    </Toast>;
};

export default ErrorToast;